import { render, staticRenderFns } from "./BotsTable.vue?vue&type=template&id=d9c8dd3e&"
import script from "./BotsTable.vue?vue&type=script&lang=js&"
export * from "./BotsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports